var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"delete text-xs md:text-sm",attrs:{"aria-label":_vm.$t('Components.DeleteButton.removeItem')},on:{"click":function($event){return _vm.$emit('click')}}},[_c('i',{staticClass:"fal fa-trash mr-2",attrs:{"aria-hidden":"true"}}),_c('span',{staticClass:"text-xs md:text-sm"},[_vm._v(" "+_vm._s(_vm.custom_caption)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }